import botLogin from "./bot-login";

export default {
  'bot-login': botLogin
};
